function loadWidget(widgetId) {
    const a = window, d = document;

    // Remove previous widget if any (important when switching pages)
    const existing = d.querySelector('script[data-widget="goftino"]');
    if (existing) existing.remove();

    // Create new script with correct ID
    function g() {
        const script = d.createElement("script");
        script.setAttribute("data-widget", "goftino");
        const s = "https://chat.medrick.info/widget/" + widgetId;
        const l = localStorage.getItem("goftino_" + widgetId);
        script.async = true;
        script.src = l ? s + "?o=" + l : s;
        d.head.appendChild(script);
    }

    if (d.readyState === "complete") g();
    else if (a.attachEvent) a.attachEvent("onload", g);
    else a.addEventListener("load", g, false);
}

export default function GoftinoWidget({widget_id}) {
    loadWidget(widget_id || "Rhvww8");
}
